/**
 * función que devuelve un objeto con todos los atributos de un elemento HTMLElement, quitando los "data-"
 */

export function getAttributes(elem) {
  const attrs = {};
  for (let i = 0, len = elem.attributes.length; i < len; i++) {
    const name = (elem.attributes[i].nodeName || elem.attributes[i].name).replace('data-', '');
    attrs[name] = elem.attributes[i].value;
  }
  return attrs;
}
